import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain,DispatchSetFilterQuery, DispatchSetProductFilters } from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";

type HandlerType = HandlerWithResult<ProductFilters, ProductFilters>;

export const DispatchSetFilterQueryEmpty: HandlerType = props => {

};

replaceInChain(chain,DispatchSetFilterQuery,DispatchSetFilterQueryEmpty);
// replaceInChain(chain,DispatchSetProductFilters,DispatchSetProductFiltersEmpty);
